import { authStorage } from 'storages/authStorage';
import { getLogoutUrl } from 'app/services/AuthService/config';

export const logout = (redirectUrl?: string) => {
  authStorage.cleanJwtAuthParams();

  window.location.href = getLogoutUrl(redirectUrl);
};
